import React from 'react';
import { Label } from '../../types/labels';

interface LabelDisplayProps {
	tag: Label;
	className?: string;
	style?: React.CSSProperties;
	showassociatedPartsCount?: boolean;
	darkMode?: boolean;
}

const LabelDisplay: React.FC<LabelDisplayProps> = ({
	tag,
	className = '',
	style = {},
	showassociatedPartsCount = false,
	darkMode = false,
}) => {
	return (
		<span
			className={`bodyregular inline-flex items-center justify-between gap-2 align-middle text-black/45 ${className}`}
			style={style}
		>
			<span className="inline-flex items-center gap-2">
				<span
					className="inline-block h-3 w-3 flex-shrink-0 rounded-full"
					style={{
						backgroundColor: tag.color,
						borderWidth: darkMode ? 1 : 0,
						borderColor: darkMode ? '#F0F0F0' : 'transparent',
						borderStyle: darkMode ? 'solid' : 'none',
					}}
				/>
				<span className={`${darkMode ? 'text-grey-4' : ''}`}>{tag.label}</span>
			</span>
			{showassociatedPartsCount && typeof tag.associatedPartsCount === 'number' ? (
				<span className="text-black/45">({tag.associatedPartsCount})</span>
			) : null}
		</span>
	);
};

export default LabelDisplay;
